// Extra guest fee is charged per room type: every unit of the same room type in the booking carries the
// group's total pax, and each unit includes `extraGuest.number` guests for free.
export const calculateExtraGuestFee = (extraGuest, pax, numberOfUnits = 1) => {
  if (!extraGuest || !extraGuest.number || !extraGuest.amount) {
    return 0;
  }

  const extraGuestNumber = Number(pax) - extraGuest.number * numberOfUnits;
  return extraGuestNumber > 0 ? extraGuestNumber * extraGuest.amount : 0;
};

export const calculateTotalExtraGuestFee = (units = []) => {
  const roomTypeGroups = units.reduce((groups, unit) => {
    const key = unit.roomTypeId || unit._id;
    groups[key] = groups[key] || { extraGuest: unit.extraGuest, pax: unit.adultCapacity, count: 0 };
    groups[key].count++;
    return groups;
  }, {});

  return Object.values(roomTypeGroups).reduce((total, { extraGuest, pax, count }) => total + calculateExtraGuestFee(extraGuest, pax, count), 0);
};
